export const calculateObjectPosition = (src: string, focalPoints?: string) => {
    try {
        const originalImageSizeRegex = /\/(\d+)x(\d+)\//;
        const originalImageSize = src.toString()?.match(originalImageSizeRegex) ?? [];
        const originalImageWidth = originalImageSize[1];
        const originalImageHeight = originalImageSize[2];

        const focalPointsSizeRegex = /(\d+)x(\d+)/;
        const focalPointsSize = focalPoints?.match(focalPointsSizeRegex) ?? [];
        const focalPointX = focalPointsSize[1];
        const focalPointY = focalPointsSize[2];

        const calculateObjectPositionPercentage = (originalSize?: string, focalPointSize?: string) => {
            if (!originalSize || !focalPointSize) {
                return '50%';
            }

            return `${Math.round((Number(focalPointSize) * 100) / Number(originalSize))}%`;
        };

        const objectPositionX = calculateObjectPositionPercentage(originalImageWidth, focalPointX);
        const objectPositionY = calculateObjectPositionPercentage(originalImageHeight, focalPointY);

        return `${objectPositionX} ${objectPositionY}`;
    } catch (_) {
        return '50%';
    }
};
